import { render } from "./accountDetail.vue?vue&type=template&id=89b4ba54&scoped=true&ts=true"
import script from "./accountDetail.vue?vue&type=script&lang=ts"
export * from "./accountDetail.vue?vue&type=script&lang=ts"

import "./accountDetail.vue?vue&type=style&index=0&id=89b4ba54&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-89b4ba54"]])

export default __exports__